<template>
  <SettingSection
    title="Инструменты"
    icon-variant="tools"
    :icon="icon"
    :links="links"
  />
</template>

<script>
import SettingSection from "@/components/Settings/SettingSection.vue";

export default {
  name: "ToolsSettingsSection",

  components: {
    SettingSection,
  },

  data() {
    return {
      icon: `
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.1-3.1a6 6 0 0 1-7.9 7.9l-5.7 5.7a2 2 0 0 1-2.8-2.8l5.7-5.7a6 6 0 0 1 7.9-7.9l-3.3 2.9z" />
      `,
      links: [
        {
          label: "Настройки калькуляторов",
          route: { name: "CalculatorPresets" },
        },
      ],
    };
  },
};
</script>
